import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EntityCrudService } from '@data/entity-crud.service';
import { CustomTopic } from '@data/custom-topic/custom-topic.model';

@Injectable({
  providedIn: 'root',
})
export class CustomTopicService extends EntityCrudService<CustomTopic, CustomTopic> {
  constructor() {
    const http = inject(HttpClient);

    super('custom-topics', http);
  }
}
